import { TicketStatus } from './types';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DateFormat } from '@cp/src/utils/DateHelper';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export const getTagColor = (label: string) => {
  if (label === TicketStatus.TODO) {
    return 'orange';
  }
  if (label === TicketStatus.IN_PROGRESS) {
    return 'blue';
  }
  if (label === TicketStatus.CLOSED) {
    return 'green';
  }
  return 'primary';
};

export const timeAgo = (epoch: number) => {
  const now = dayjs();
  const time = dayjs(epoch);

  if (now.diff(time, 'day') >= 1) {
    return time.format(DateFormat.DD_MMM_YYYY_hh_mm_a);
  }

  return time.fromNow();
};
